class ShopYourSizeSlider {
  constructor(slider) {
    this.slider = slider;

    this.pointerDown = false;
    this.isDragging = false;
    this.preventNextClick = false;

    this.startX = 0;
    this.startScrollLeft = 0;
    this.pointerId = null;

    this.dragThreshold = 8;

    this.bindEvents();
  }

  bindEvents() {
    this.slider.addEventListener(
      'pointerdown',
      this.onPointerDown.bind(this)
    );

    this.slider.addEventListener(
      'pointermove',
      this.onPointerMove.bind(this)
    );

    this.slider.addEventListener(
      'pointerup',
      this.onPointerUp.bind(this)
    );

    this.slider.addEventListener(
      'pointercancel',
      this.onPointerUp.bind(this)
    );

    this.slider.addEventListener(
      'click',
      this.onClick.bind(this),
      true
    );
  }

  onPointerDown(event) {
    /* Let touch devices use native scrolling */
    if (event.pointerType === 'touch') return;

    /* Primary mouse button only */
    if (event.button !== 0) return;

    this.pointerDown = true;
    this.isDragging = false;
    this.preventNextClick = false;

    this.pointerId = event.pointerId;

    this.startX = event.clientX;
    this.startScrollLeft = this.slider.scrollLeft;
  }

  onPointerMove(event) {
    if (!this.pointerDown) return;

    const distance = event.clientX - this.startX;

    /*
     * Don't start dragging until there has been
     * meaningful horizontal movement.
     */
    if (!this.isDragging) {
      if (Math.abs(distance) < this.dragThreshold) {
        return;
      }

      this.isDragging = true;
      this.preventNextClick = true;

      this.slider.classList.add('is-dragging');

      try {
        this.slider.setPointerCapture(this.pointerId);
      } catch (error) {
        // Pointer capture isn't essential.
      }
    }

    event.preventDefault();

    this.slider.scrollLeft =
      this.startScrollLeft - distance;
  }

  onPointerUp() {
    if (!this.pointerDown) return;

    this.pointerDown = false;

    if (this.isDragging) {
      this.slider.classList.remove('is-dragging');

      try {
        this.slider.releasePointerCapture(this.pointerId);
      } catch (error) {
        // Ignore if pointer capture was not active.
      }
    }

    this.isDragging = false;
    this.pointerId = null;
  }

  onClick(event) {
    /*
     * Block the click only when the user actually dragged.
     */
    if (!this.preventNextClick) return;

    event.preventDefault();
    event.stopPropagation();

    this.preventNextClick = false;
  }
}


/* =========================================================
   ACTIVE SIZE BUTTON
   ========================================================= */

function updateShopYourSizeActiveButtons(scope = document) {
  const currentUrl = decodeURIComponent(window.location.href);

  scope
    .querySelectorAll('.shop-your-size-button')
    .forEach((button) => {
      const href = decodeURIComponent(
        button.getAttribute('href') || ''
      );

      const isActive =
        href !== '' &&
        href !== '#' &&
        currentUrl.includes(href);

      button.classList.toggle(
        'is-active',
        isActive
      );

      if (isActive) {
        button.setAttribute(
          'aria-current',
          'page'
        );
      } else {
        button.removeAttribute(
          'aria-current'
        );
      }
    });
}


/* =========================================================
   INITIALISE SLIDERS
   ========================================================= */

function initShopYourSizeSliders(scope = document) {
  scope
    .querySelectorAll(
      '[data-shop-your-size-slider]:not([data-slider-initialized])'
    )
    .forEach((slider) => {
      slider.setAttribute(
        'data-slider-initialized',
        'true'
      );

      new ShopYourSizeSlider(slider);
    });
}


/* =========================================================
   INITIAL LOAD
   ========================================================= */

document.addEventListener('DOMContentLoaded', () => {
  initShopYourSizeSliders();
  updateShopYourSizeActiveButtons();
});


/* =========================================================
   URL FILTER CHANGE
   ========================================================= */

window.addEventListener('hashchange', () => {
  updateShopYourSizeActiveButtons();
});


/* =========================================================
   SHOPIFY THEME EDITOR
   ========================================================= */

document.addEventListener('shopify:section:load', (event) => {
  initShopYourSizeSliders(event.target);
  updateShopYourSizeActiveButtons(event.target);
});